import _ from 'lodash';

import {Component, Module} from 'app/decorators';

import tpl from './list.html';
import TicketStore from 'app/stores/ticket';


@Module({
    name: "app.tickets.components.priority-list",
    modules: [
        TicketStore
    ],
})
@Component({
    selector: 'ticket-priority-list',
    template: tpl,
})
export default class C {
    constructor (TicketStore, $element) {
        "ngInject";
        this.$element = $element;
        this.store = TicketStore;
        this.store.init();
        delete this.store.params.date;
        this.store.params.ordering = ['sort_order'];
        this.store.params.status = 'pending';
        this.store.params.field = ['id', 'ticketnumber', 'customer', 'fields', 'crop', 'created_at', 'applicators', 'haulers', 'analysis'];
        this.store.refresh();
        this.saving = false;
    }

    onMoved ($index) {
        let self = this;
        self.store.list.splice($index, 1)
    }

    onDrop (event, index, item, external, type) {
        let self = this;
        item = self.store.restangularize(item);
        let data = {
            after: this.store.list[index-1],
            before: this.store.list[index],
        };
        self.saving = true;
        item.customPUT(data, 'sort_order')
            .then(i => item.sort_order = i.sort_order)
            .finally(() => self.saving = false);
        return item;
    }

    loadMore () {
        this.store.loadMore();
    }

    $onDestroy () {
        this.store = null;
        this.$element.remove();
        this.$element = null;
    }
}



// WEBPACK FOOTER //
// ./src/app/tickets/components/priority/main.js